<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-card class="ui-module-card" color="primary" :loading="loading">
              <v-card-text>
                <v-row justify="end">
                  <v-col cols="12" lg="5">
                    <v-text-field
                      v-model="busqueda"
                      class="mb-2"
                      dense
                      filled
                      rounded
                      color="secondary"
                      background-color="transparent"
                      label="Buscar por personal u observación"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="observaciones"
                  :search="busqueda"
                  :items-per-page="15"
                  :footer-props="{ itemsPerPageOptions: [10, 15, 25, 50, -1] }"
                  item-key="idResultado"
                  class="transparent mt-3"
                >
                  <template v-slot:[`item.nombrePersonal`]="{ item }">
                    {{ item.nombrePersonal || '—' }}
                  </template>
                  <template v-slot:[`item.observacion`]="{ item }">
                    {{ item.observacion }}
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <IconButton
                            variant="secondary"
                            elevation="8"
                            icon="mdi-text-box-check-outline"
                            @click="abrirSeguimientos(item)"
                          />
                        </span>
                      </template>
                      <span>Gestionar seguimientos</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <seguimiento-observacion-dialog-component
      :active="dialogoSeguimientos"
      :observacion="observacionParaDialogo"
      @close="cerrarSeguimientos"
    ></seguimiento-observacion-dialog-component>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'
import SeguimientoObservacionDialogComponent from './SeguimientoObservacionDialogComponent.vue'
import { TIPO_MODULO_INTERVENCION } from '@/modules/intervencion-c3/domain/tipoModuloIntervencion'
import { TIPOS_OBSERVACION } from '@/modules/seguimientos-resultado-c3/domain/tiposObservacion'

// El endpoint GET .../intervencion/tipo/{type} no retorna tipoObservacion (confirmado contra dev, ver tasks.md 12.4/13.7).
// Se deriva client-side a partir de tipoModuloIntervencion, ya que Armería/Academia mapean 1:1 con observacionesAdicionalesA/observacionesAdicionalesB.
const TIPO_OBSERVACION_POR_MODULO = {
  [TIPO_MODULO_INTERVENCION.ARMERIA]: TIPOS_OBSERVACION.ARMERIA,
  [TIPO_MODULO_INTERVENCION.ACADEMIA]: TIPOS_OBSERVACION.ACADEMIA,
}

export default {
  name: 'IntervencionActivaListComponent',
  components: {
    IconButton,
    SeguimientoObservacionDialogComponent,
  },
  props: {
    // Valor numérico de tipoModuloIntervencion (2 = Armería, 3 = Academia)
    tipoModulo: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Personal', value: 'nombrePersonal' },
        { text: 'Observación', value: 'observacion' },
        { text: '', value: 'opciones', sortable: false, align: 'end' },
      ],
      dialogoSeguimientos: false,
      observacionSeleccionada: null,
      busqueda: '',
    }
  },
  computed: {
    ...mapGetters('intervencionC3', {
      observaciones: 'getObservaciones',
      loading: 'getLoading',
    }),
    observacionParaDialogo() {
      if (!this.observacionSeleccionada) return null
      return {
        ...this.observacionSeleccionada,
        tipoObservacion: TIPO_OBSERVACION_POR_MODULO[this.tipoModulo],
      }
    },
  },
  created() {
    this.cargarObservaciones()
  },
  methods: {
    ...mapActions('intervencionC3', ['fetchObservacionesIntervencionActiva']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async cargarObservaciones() {
      try {
        await this.fetchObservacionesIntervencionActiva(this.tipoModulo)
      } catch (error) {
        console.error('[IntervencionActivaListComponent] cargarObservaciones failed:', error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al cargar las observaciones con intervención activa.')
      }
    },

    abrirSeguimientos(item) {
      this.observacionSeleccionada = item
      this.dialogoSeguimientos = true
    },

    cerrarSeguimientos() {
      this.dialogoSeguimientos = false
      this.observacionSeleccionada = null
    },
  },
}
</script>
